import React from 'react'
import styles from './CaseFirstViewItemWhite.module.scss'
import Tags from 'components/commons/TagsGray/TagsGray'
import { useEffect, useRef, ComponentPropsWithoutRef } from 'react'
import { gsap, Power4 } from 'gsap'
import Link from 'next/link'

type CaseFirstViewItemProps = {
  title1: string | React.ReactNode
  subtitle?: string
  company: string
  introduction_text: string | React.ReactNode
  tag1text: string
  tag2text?: string
  tag3text?: string
  tag4text?: string
  tag1src: string
  tag2src?: string
  tag3src?: string
  tag4src?: string
  linkText?: string
  linkUrl?: string
  industryTagText?: string
  industryTagSrc?: string
} & ComponentPropsWithoutRef<'div'>

const tweenVars: gsap.TimelineVars = [
  {
    y: '50',
    duration: 1,
    opacity: 0,
    ease: Power4.easeOut,
  },
]

const CaseFirstViewItemWhite: React.FC<CaseFirstViewItemProps> = ({
  title1,
  subtitle,
  company,
  introduction_text,
  tag1text,
  tag2text,
  tag3text,
  tag4text,
  tag1src,
  tag2src,
  tag3src,
  tag4src,
  industryTagText,
  industryTagSrc,
  linkText,
  linkUrl,
}) => {
  const timeline = gsap.timeline()

  const title = useRef<HTMLDivElement>()
  const sub_title = useRef<HTMLDivElement>()
  const introduction = useRef<HTMLParagraphElement>()
  const sub_text = useRef<HTMLDivElement>()
  const link = useRef<HTMLDivElement>()
  const tag = useRef<HTMLDivElement>()

  const firstCheckRef = useRef<boolean>(false)

  useEffect(() => {
    if (!firstCheckRef.current) {
      timeline
        .from(title.current, tweenVars[0], 0.5)
        .from(sub_title.current, tweenVars[0], 0.5)
        .from(sub_text.current, tweenVars[0], 0.8)
        .from(introduction.current, tweenVars[0], 1.1)
        .from(link.current, tweenVars[0], 1.1)
        .from(tag.current, tweenVars[0], 1.4)
      firstCheckRef.current = true
    }
  }, [])

  return (
    <>
      <div className={styles.fv}>
        <div className={styles.fv_inner}>
          <div className={styles.fv_inner_subttl} ref={sub_title}>
            {subtitle ?? <h2>{subtitle}</h2>}
          </div>
          <h1 className={styles.fv_inner_ttl} ref={title}>
            {title1}
          </h1>
          <div className={styles.fv_inner_sub}>
            <p className={styles.fv_inner_sub_company} ref={sub_text}>
              {company}
            </p>
            {linkText && (
              <p className={styles.fv_inner_link} ref={link}>
                <a href={linkUrl} target="_blank">
                  {linkText}
                </a>
              </p>
            )}
          </div>
          <p className={styles.fv_inner_txt} ref={introduction}>
            {introduction_text}
          </p>
          <div className={styles.fv_inner_tags} ref={tag}>
            <Tags
              tag1src={tag1src}
              tag1text={tag1text}
              tag2src={tag2src}
              tag2text={tag2text}
              tag3src={tag3src}
              tag3text={tag3text}
              tag4src={tag4src}
              tag4text={tag4text}
              industryTagText={industryTagText}
              industryTagSrc={industryTagSrc}
            />
          </div>
        </div>
      </div>
    </>
  )
}

export default CaseFirstViewItemWhite
